site.labelFocus = {
	init: function () {
		if ($('body').is('admin')) return false;

		var $form = $('form');
		if ($form.length) {
			$form.find('input[type="text"], textarea').focus(function () {
				$(this).parents('.elm').addClass('focus');
			}).blur(function () {
				if ($(this).val() === '') {
					$(this).parents('.elm').removeClass('focus');
				}
			}).each(function() {
				if ($(this).attr('value') !== '') {
					$(this).parents('.elm').addClass('focus');
				}
			});
		}
	}
};

//site.inits.push('site.labelFocus.init()');
